
import Vue from 'vue'
import Component from 'vue-class-component'

import TempAccount from '@/models/tempAccount'

import GreenButton from '../Atomic/GreenButton.vue'
import RedButton from '../Atomic/RedButton.vue'

@Component({
  components: {
    GreenButton,
    RedButton,
  },
})
export default class TempAccountPrint extends Vue {
  private dialog: boolean = false

  private account: TempAccount = {} as TempAccount

  private show(repositoryTempAccount: TempAccount) {
    this.dialog = true
    this.account = repositoryTempAccount
  }

  private print() {
    const component: any = this.$refs.printable
    const html: string = component.$el.innerHTML
    if (html !== '') {
      let style = ''
      for (const node of [
        ...document.querySelectorAll('link[rel="stylesheet"], style'),
      ]) {
        style += node.outerHTML
      }

      const printWindow = window.open()
      if (printWindow != null) {
        printWindow.document.write(
          `<!DOCTYPE html><html><head>${style}</head><body>${html}</body></html>`,
        )
        printWindow.document.close()
        printWindow.focus()
        printWindow.print()
        printWindow.close()
      }
    }
  }

  private close() {
    this.dialog = false
  }
}
